import "localcopy-mdbootstrap-pro/src/js/free/forms-free";
import "localcopy-mdbootstrap-pro/src/js/free/scrolling-navbar";
import "localcopy-mdbootstrap-pro/src/js/free/treeview";
import "localcopy-mdbootstrap-pro/src/js/free/wow";
import "localcopy-mdbootstrap-pro/src/js/pro/buttons";
import "localcopy-mdbootstrap-pro/src/js/pro/cards";
import "localcopy-mdbootstrap-pro/src/js/pro/character-counter";
import "localcopy-mdbootstrap-pro/src/js/pro/chips";
import "localcopy-mdbootstrap-pro/src/js/pro/collapsible";
import "localcopy-mdbootstrap-pro/src/js/pro/dropdown/dropdown";
import "localcopy-mdbootstrap-pro/src/js/pro/dropdown/dropdown-searchable";
import "localcopy-mdbootstrap-pro/src/js/pro/file-input";
import "localcopy-mdbootstrap-pro/src/js/pro/material-select/material-select";
import "localcopy-mdbootstrap-pro/src/js/pro/material-select/material-select-view";
import "localcopy-mdbootstrap-pro/src/js/pro/material-select/material-select-view-renderer";
import "localcopy-mdbootstrap-pro/src/js/pro/mdb-autocomplete";
import "localcopy-mdbootstrap-pro/src/js/pro/picker";
import "localcopy-mdbootstrap-pro/src/js/pro/picker-date";
import "localcopy-mdbootstrap-pro/src/js/pro/picker-time";
import "localcopy-mdbootstrap-pro/src/js/pro/preloading";
import "localcopy-mdbootstrap-pro/src/js/pro/range-input";
import "localcopy-mdbootstrap-pro/src/js/pro/sidenav";
import "localcopy-mdbootstrap-pro/src/js/pro/sidenav2";
import "localcopy-mdbootstrap-pro/src/js/pro/smooth-scroll";
import "localcopy-mdbootstrap-pro/src/js/pro/sticky";
import "localcopy-mdbootstrap-pro/src/js/vendor/addons-pro/chat";
import "localcopy-mdbootstrap-pro/src/js/vendor/addons-pro/multi-range";
import "localcopy-mdbootstrap-pro/src/js/vendor/addons-pro/simple-charts";
import "localcopy-mdbootstrap-pro/src/js/vendor/addons-pro/steppers";
import "localcopy-mdbootstrap-pro/src/js/vendor/addons-pro/timeline";
import "localcopy-mdbootstrap-pro/src/js/vendor/addons/datatables";
import "localcopy-mdbootstrap-pro/src/js/vendor/addons/datatables-select";
import "localcopy-mdbootstrap-pro/src/js/vendor/addons/datatables-select2";
import "localcopy-mdbootstrap-pro/src/js/vendor/addons/datatables2";
import "localcopy-mdbootstrap-pro/src/js/vendor/addons/imagesloaded.pkgd.min";
import "localcopy-mdbootstrap-pro/src/js/vendor/addons/jquery.zmd.hierarchical-display";
import "localcopy-mdbootstrap-pro/src/js/vendor/addons/masonry.pkgd.min";
import "localcopy-mdbootstrap-pro/src/js/vendor/addons/rating";
//import "localcopy-mdbootstrap-pro/src/js/vendor/free/chart";
//import "localcopy-mdbootstrap-pro/src/js/vendor/free/chartjs-datalabels";
import "localcopy-mdbootstrap-pro/src/js/vendor/free/enhanced-modals";
import "localcopy-mdbootstrap-pro/src/js/vendor/free/jquery.easing";
import "localcopy-mdbootstrap-pro/src/js/vendor/free/velocity";
import "localcopy-mdbootstrap-pro/src/js/vendor/free/waves";
import "localcopy-mdbootstrap-pro/src/js/vendor/pro/jarallax";
import "localcopy-mdbootstrap-pro/src/js/vendor/pro/jarallax-video";
import "localcopy-mdbootstrap-pro/src/js/vendor/pro/jquery.sticky";
import "localcopy-mdbootstrap-pro/src/js/vendor/pro/lightbox";
import "localcopy-mdbootstrap-pro/src/js/vendor/pro/ofi";
import "localcopy-mdbootstrap-pro/src/js/vendor/pro/picker";
import "localcopy-mdbootstrap-pro/src/js/vendor/pro/picker-date";
import "localcopy-mdbootstrap-pro/src/js/vendor/pro/picker-date-time";
import "localcopy-mdbootstrap-pro/src/js/vendor/pro/picker-time";
import "localcopy-mdbootstrap-pro/src/js/vendor/pro/scrollbar";
import "localcopy-mdbootstrap-pro/src/js/vendor/pro/scrolling-navbar";
import "localcopy-mdbootstrap-pro/src/js/vendor/pro/vector-map";
import "localcopy-mdbootstrap-pro/src/js/vendor/pro/vector-map-world-mill";

global.bsCustomFileInput = require("localcopy-mdbootstrap-pro/src/js/vendor/free/bs-custom-file-input");
window.toastr = require("localcopy-mdbootstrap-pro/src/js/vendor/pro/toastr");
